var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Login", {
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function() {
          return [
            _c("span", { attrs: { id: "loginTitle" } }, [
              _vm._v(_vm._s(_vm.$t("Hello")) + "!")
            ]),
            _vm._v(" "),
            _c("span", { attrs: { id: "loginMessage" } }, [
              _vm._v(_vm._s(_vm.$t("LetsStartWorking")))
            ])
          ]
        },
        proxy: true
      },
      {
        key: "form",
        fn: function() {
          return [
            _c("form", { staticClass: "loginForm" }, [
              _c("div", { staticClass: "main-login-form-container" }, [
                !_vm.keyIsNecessary
                  ? _c("div", { staticClass: "email-div" }, [
                      _c("span", { staticClass: "login-input-label" }, [
                        _vm._v(_vm._s(_vm.$t("Email")))
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.email,
                            expression: "email"
                          }
                        ],
                        ref: "email",
                        staticClass: "loginInput userInput effect-7",
                        class: { fieldErrorInput: _vm.badEmail },
                        attrs: {
                          type: "email",
                          name: "email",
                          spellcheck: "false"
                        },
                        domProps: { value: _vm.email },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.loginSubmit.apply(null, arguments)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.email = $event.target.value
                          }
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.keyIsNecessary
                  ? _c(
                      "div",
                      { staticClass: "password-div" },
                      [
                        _c("span", { staticClass: "login-input-label" }, [
                          _vm._v(_vm._s(_vm.$t("Password")))
                        ]),
                        _vm._v(" "),
                        _vm.type === "checkbox"
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.password,
                                  expression: "password"
                                }
                              ],
                              staticClass: "loginInput passwordInput effect-7",
                              class: { fieldErrorInput: _vm.badPassword },
                              attrs: { name: "pass", type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.password)
                                  ? _vm._i(_vm.password, null) > -1
                                  : _vm.password
                              },
                              on: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.loginSubmit.apply(null, arguments)
                                },
                                change: function($event) {
                                  var $$a = _vm.password,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.password = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.password = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.password = $$c
                                  }
                                }
                              }
                            })
                          : _vm.type === "radio"
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.password,
                                  expression: "password"
                                }
                              ],
                              staticClass: "loginInput passwordInput effect-7",
                              class: { fieldErrorInput: _vm.badPassword },
                              attrs: { name: "pass", type: "radio" },
                              domProps: { checked: _vm._q(_vm.password, null) },
                              on: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.loginSubmit.apply(null, arguments)
                                },
                                change: function($event) {
                                  _vm.password = null
                                }
                              }
                            })
                          : _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.password,
                                  expression: "password"
                                }
                              ],
                              staticClass: "loginInput passwordInput effect-7",
                              class: { fieldErrorInput: _vm.badPassword },
                              attrs: { name: "pass", type: _vm.type },
                              domProps: { value: _vm.password },
                              on: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.loginSubmit.apply(null, arguments)
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.password = $event.target.value
                                }
                              }
                            }),
                        _vm._v(" "),
                        _c(
                          "v-icon",
                          {
                            staticClass: "password-icon",
                            on: { click: _vm.showPassword }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.type != "password"
                                  ? " mdi-eye-off"
                                  : "mdi-eye"
                              )
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.keyIsNecessary
                  ? _c("div", { staticClass: "twofa-div" }, [
                      _c("span", { staticClass: "login-input-label" }, [
                        _vm._v(_vm._s(_vm.$t("TwoFactorAuthenticationKey")))
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.key,
                            expression: "key"
                          }
                        ],
                        staticClass: "loginInput twoFaInput effect-7",
                        class: { fieldErrorInput: _vm.badKey },
                        attrs: { type: "text", name: "key" },
                        domProps: { value: _vm.key },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.loginSubmit.apply(null, arguments)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.key = $event.target.value
                          }
                        }
                      })
                    ])
                  : _vm._e()
              ])
            ])
          ]
        },
        proxy: true
      },
      {
        key: "button",
        fn: function() {
          return [
            _c(
              "v-btn",
              {
                staticClass: "signInInput",
                attrs: {
                  type: "submit",
                  loading: _vm.loading,
                  disabled: _vm.submitButtonDisable,
                  color: "accent--text",
                  outlined: ""
                },
                on: { click: _vm.loginSubmit }
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      !_vm.keyIsNecessary ? _vm.$t("Login") : _vm.$t("Continue")
                    ) +
                    "\n    "
                )
              ]
            )
          ]
        },
        proxy: true
      },
      {
        key: "remember-me-reset-password",
        fn: function() {
          return [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.keyIsNecessary,
                    expression: "!keyIsNecessary"
                  }
                ],
                staticClass: "field-error-div"
              },
              [
                _vm.badPassword
                  ? _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("InvalidCredentials")) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.noCompany
                  ? _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("NoCompanyAssociated")) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.userInactive
                  ? _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("UserInactive")) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.companyInactive
                  ? _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("CompanyInactive")) +
                          "\n      "
                      )
                    ])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _vm.badKey
              ? _c("div", { staticClass: "field-error-div" }, [
                  _c("span", [
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("Keyisinvalid")) + "\n      "
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.keyIsNecessary
              ? _c(
                  "div",
                  { staticClass: "passwordRecoveryDiv" },
                  [
                    _c("InputField", {
                      attrs: {
                        inputType: "checkbox",
                        value: _vm.savePassword,
                        "checkbox-options": _vm.checkboxOptions,
                        height: 16,
                        width: 16,
                        border: "0px",
                        checkboxLabelStyle: _vm.checkboxLabelStyle,
                        size: "50",
                        inputStyle: _vm.inputStyle
                      },
                      on: {
                        input: function($event) {
                          return _vm.handleCheckboxChange()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "forgotPasswordLink",
                        on: { click: _vm.forgotHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("ForgotPassword")))]
                    )
                  ],
                  1
                )
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e961f52", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e961f52","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/LoginPage.vue
// module id = null
// module chunks = 